module.exports = __webpack_public_path__ + "img/pr-7.4c351c0c.png";